import clsx from 'clsx';
import React from 'react';

import { OfferOption } from '@utils/backend-api/subscribe';

interface OfferPriceProps {
  className?: string;
  offer: OfferOption;
}

const OfferPrice = ({
  className,
  offer: {
    currentPrice,
    currentPriceDisplayOverride,
    originalPrice,
    originalPriceDisplayOverride,
    billingFrequencyOverride,
  },
}: OfferPriceProps) => {
  const currentPriceToDisplay = currentPriceDisplayOverride || currentPrice;
  const hasDiscount = originalPrice !== currentPrice;
  const originalPriceToDisplay = originalPriceDisplayOverride || originalPrice;
  return (
    <div className={clsx('flex flex-wrap items-center justify-center', className)}>
      <span className="font-suisse-screen text-disclosure-lg !font-medium text-grayscale-charcoal sm:text-headline-alt-sm">
        ${currentPriceToDisplay.toFixed(2)}
      </span>
      {hasDiscount && (
        <span className="ml-8 font-suisse-screen text-disclosure-lg italic text-grayscale-gray line-through sm:text-headline-alt-sm">
          ${originalPriceToDisplay.toFixed(2)}
        </span>
      )}
      {billingFrequencyOverride && (
        <span className="ml-8 whitespace-nowrap font-suisse-screen text-disclosure-lg text-grayscale-charcoal">
          {billingFrequencyOverride}
        </span>
      )}
    </div>
  );
};

export default OfferPrice;
